import axios from 'axios'
import Constants from '../constants'

export default {
  getGenres: (lang) => {
    return new Promise((resolve) => {
      axios.get('tags', { params: { id: Constants.API_ID, language: lang } })
        .then(payload => {
          let genres = []
          payload.data.items.forEach((g) => {
            const genre = {
              id: g.id,
              name: g.name,
              menu: g.menu,
              filter: g.filter,
              filterName: g.filterName,
              filterCaptions: g.filterCaptions,
              filterDefault: g.filterDefault,
              filterIcon: g.filterIcon,
              planTop: g.planTop,
              type: g.type,
              relatedFilters: g.relatedFilters,
              exlusive: g.exlusive
            }
            if (g.items) {
              genre.children = g.items
              genre.isChildOpen = false
            }
            genres.push(genre)
          })
          resolve(genres)
        });
    })
  }
}
